'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var defineProperty = require('../../../node_modules/@babel/runtime/helpers/defineProperty.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var withStyles = require('../../Styles/withStyles.js');
require('prop-types');
var TextField = require('../TextFields/TextField.js');
var Search$2 = require('../../../IconsAndImages/Icons/Search.js');
var Close = require('../../../IconsAndImages/Icons/Close.js');
var CircularProgress = require('../../Feedback/Progress/CircularProgress.js');
var classNames = require('classnames');
var Theme = require('../../../Theme/Theme.js');
require('../../../Theme/DarkTheme.js');
require('../../../Theme/LightTheme.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var classNames__default = /*#__PURE__*/_interopDefaultLegacy(classNames);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = function styles(theme) {
  return {
    search: {
      paddingLeft: 12,
      backgroundColor: theme.palette.grey[100],
      '&:hover': {
        backgroundColor: theme.palette.grey[200]
      },
      marginLeft: 0,
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.secondary.light
    },
    searchIcon: {
      height: '100%',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      marginRight: 8
    },
    inputRoot: {
      color: theme.palette.secondary.main,
      width: '100%'
    },
    inputRootLarge: {
      color: theme.palette.secondary.main,
      width: '100%',
      fontSize: 16,
      padding: '12px 12px 12px 0'
    },
    rightIconContainer: {
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 24,
      marginRight: 8,
      flexShrink: 0
    },
    rightIcon: {
      color: theme.palette.secondary.light
    },
    clearIcon: {
      cursor: 'pointer'
    }
  };
};

var Search = function Search(_ref) {
  var classes = _ref.classes,
      size = _ref.size,
      placeholder = _ref.placeholder,
      showError = _ref.showError,
      loading = _ref.loading,
      onClear = _ref.onClear,
      showClear = _ref.showClear,
      rounded = _ref.rounded,
      restProps = objectWithoutProperties(_ref, ["classes", "size", "placeholder", "showError", "loading", "onClear", "showClear", "rounded"]);

  var inputStyle = _objectSpread({}, showError ? {
    backgroundColor: '#fce8e6'
  } : {}, {}, rounded ? {
    borderRadius: 20
  } : {
    borderRadius: Theme.theme.shape.borderRadius
  });

  var controls = loading ? React__default["default"].createElement(CircularProgress, {
    className: classes.rightIcon,
    size: 16
  }) : React__default["default"].createElement(Close, {
    width: "22",
    height: "22",
    className: classNames__default["default"](classes.rightIcon, classes.clearIcon),
    onClick: onClear
  });
  return React__default["default"].createElement("div", {
    className: classes.search,
    style: inputStyle
  }, React__default["default"].createElement("div", {
    className: classes.searchIcon
  }, React__default["default"].createElement(Search$2, null)), React__default["default"].createElement(TextField["default"], _extends["default"]({
    variant: "standard",
    classes: {
      root: size === 'large' ? classes.inputRootLarge : classes.inputRoot
    },
    InputProps: {
      disableUnderline: true
    }
  }, restProps, {
    placeholder: placeholder
  })), showClear && React__default["default"].createElement("div", {
    className: classes.rightIconContainer
  }, controls));
};

Search.defaultProps = {
  placeholder: 'Search',
  showError: false,
  showClear: false
};
var Search$1 = withStyles["default"](styles)(Search);

module.exports = Search$1;
